exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2Lw2fldsMfxaEjAoXWsSXy,._2sDvvyXFEfTUFIcboDcbn3,._20rUCNZ41fZpRRptsqiZxf{color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._2Lw2fldsMfxaEjAoXWsSXy,html[dir] ._2sDvvyXFEfTUFIcboDcbn3,html[dir] ._20rUCNZ41fZpRRptsqiZxf{background:\"[theme:composeNeutralBackground, default:#FFFFFF]\"}._2Lw2fldsMfxaEjAoXWsSXy::-ms-clear,._2sDvvyXFEfTUFIcboDcbn3::-ms-clear,._20rUCNZ41fZpRRptsqiZxf::-ms-clear{display:none}._20rUCNZ41fZpRRptsqiZxf{height:28px}._2sDvvyXFEfTUFIcboDcbn3{height:32px}", ""]);

// exports
exports.locals = {
	"findControlInput": "_2Lw2fldsMfxaEjAoXWsSXy",
	"findControlInputSmall": "_20rUCNZ41fZpRRptsqiZxf",
	"findControlInputRegular": "_2sDvvyXFEfTUFIcboDcbn3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/controls/owa-readwrite-recipient-well/lib/components/ReadWriteFindControl.scss
// module id = 3400
// module chunks = 2 3